
import React, { Component } from 'react'
import axios from 'axios'
import {NotificationContainer, NotificationManager} from 'react-notifications'
import 'react-notifications/lib/notifications.css'

const type = "customer"
class RegisterPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      username: '',
      email: '',
      contact: '',
      address: '',
      password: '',
      type: type,

    }
  }

  changeHandler = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  submitHandler = e => {
    e.preventDefault()
    console.log(this.state)
    axios
      .post('https://shoppee-clone.herokuapp.com/user', this.state,
      {
        headers : {"Content-Type" : "application/json"}
      })
      .then(response => {
        console.log(response)


        window.location.replace("/login");

      })
      .catch(error => {
        NotificationManager.error('Account Creation unsuccessfull');
        console.log(error)
      })
  }

  backtohome(event) {
    event.preventDefault();
    window.location.replace("/Login");
  }
  render() {
    const { username, email, contact, address, password } = this.state
    return (
      <div className="rounded d-flex justify-content-center " style={{ marginTop: '100px' }}>
        <div className="col-md-4 col-sm-12 shadow-lg p-5 bg-light">
          <div className="d-flex flex-row justify-content-center">
            <h3 className>Be a member today!</h3>
          </div>
          <form onSubmit={this.submitHandler}>

            <div className="p-4">
              <div className="input-group mb-3">
                <input
                  type="text"
                  name="username"
                  placeholder="Username"
                  id="username"
                  required="required"
                  value={username}
                  onChange={this.changeHandler}
                />
              </div>
              <div className="input-group mb-3">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  id="email"
                  required="required"
                  value={email}
                  onChange={this.changeHandler}
                />

              </div>
              <div className="input-group mb-3">
                <input
                  type="text"
                  name="contact"
                  placeholder="Contact"
                  id="contact"
                  required="required"
                  value={contact}
                  onChange={this.changeHandler}
                />
              </div>
              <div className="input-group mb-3">
                <input
                  type="address"
                  name="address"
                  placeholder="Address"
                  id="address"
                  required="required"
                  value={address}
                  onChange={this.changeHandler}
                />
              </div>
              <div className="input-group mb-5">
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  id="password"
                  required="required"
                  value={password}
                  onChange={this.changeHandler}
                />
              </div>
            </div>
            <div className="d-flex flex-column justify-content-center">
              <button type="submit" className="btn btn-primary text-center mt-2" id="continue">
                Confirm
              </button>
            </div>


          </form>

          <form onSubmit={this.backtohome}>
            <div className="d-flex flex-column justify-content-center">
              <button className="btn btn-danger text-white mt-2" id="back" >
                Go back
              </button>
            </div>
          </form>


          <p className="d-flex justify-content-center text-center text-danger" id="error-login" /></div>
      </div>

    )
  }
}

export default RegisterPage



